// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== PRIVACY SETTINGS STYLES ====================
   Prefix: priv- to avoid collisions
   ================================================================ */

   .priv-root {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
  
  /* ── Master Toggle ─────────────────────────────────────────────────────── */
  .priv-master-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    padding: 18px 20px;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    margin-bottom: 24px;
    transition: all 0.2s ease;
  }
  
  .priv-master-toggle:hover {
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(255, 255, 255, 0.12);
  }
  
  .priv-master-toggle-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1 1;
  }
  
  .priv-master-toggle-title {
    font-size: 14px;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.88);
    letter-spacing: 0.3px;
  }
  
  .priv-master-toggle-desc {
    font-size: 12.5px;
    color: rgba(255, 255, 255, 0.40);
    line-height: 1.55;
  }
  
  /* ── Content Section ───────────────────────────────────────────────────────── */
  .priv-content {
    animation: priv-fadeIn 0.2s ease;
    margin-bottom: 20px;
  }
  
  @keyframes priv-fadeIn {
    from {
      opacity: 0;
      transform: translateY(5px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  /* ── Info Banner ───────────────────────────────────────────────────────────── */
  .priv-info-banner {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    background: rgba(33, 150, 243, 0.08);
    border: 1px solid rgba(33, 150, 243, 0.20);
    border-radius: 10px;
    padding: 14px 16px;
    margin-top: 16px;
    animation: priv-slideIn 0.3s ease;
  }
  
  @keyframes priv-slideIn {
    from {
      opacity: 0;
      transform: translateX(-10px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
  
  .priv-info-banner span {
    font-size: 1.2rem;
    flex-shrink: 0;
    margin-top: 2px;
  }
  
  .priv-info-banner p {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.55);
    margin: 0;
    padding: 0;
    line-height: 1.65;
  }
  
  .priv-link {
    color: #64b5f6;
    text-decoration: none;
    font-weight: 600;
    transition: color 0.15s ease;
  }
  
  .priv-link:hover {
    color: #90caf9;
    text-decoration: underline;
  }
  
  /* ── Responsive Design ─────────────────────────────────────────────────────── */
  @media (max-width: 768px) {
    .priv-master-toggle {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
      padding: 16px 18px;
    }
  
    .priv-master-toggle-title {
      font-size: 13px;
    }
  
    .priv-master-toggle-desc {
      font-size: 12px;
    }
  
    .priv-info-banner {
      flex-direction: column;
      gap: 10px;
      padding: 12px 14px;
    }
  
    .priv-info-banner span {
      font-size: 1.1rem;
      margin-top: 0;
    }
  
    .priv-info-banner p {
      font-size: 12px;
    }
  }
  
  @media (max-width: 480px) {
    .priv-master-toggle {
      padding: 14px 16px;
      gap: 12px;
    }
  
    .priv-master-toggle-title {
      font-size: 12px;
    }
  
    .priv-master-toggle-desc {
      font-size: 11px;
      line-height: 1.5;
    }
  
    .priv-info-banner {
      padding: 10px 12px;
    }
  
    .priv-info-banner p {
      font-size: 11px;
    }
  }
  
  /* ── Dark Theme Compatibility ──────────────────────────────────────────────────── */
  [data-theme="dark"] .priv-master-toggle {
    background: rgba(255, 255, 255, 0.02);
    border-color: rgba(255, 255, 255, 0.06);
  }
  
  [data-theme="dark"] .priv-master-toggle:hover {
    background: rgba(255, 255, 255, 0.04);
    border-color: rgba(255, 255, 255, 0.10);
  }
  
  [data-theme="light"] .priv-master-toggle {
    background: rgba(0, 0, 0, 0.02);
    border-color: rgba(0, 0, 0, 0.08);
  }
  
  [data-theme="light"] .priv-master-toggle:hover {
    background: rgba(0, 0, 0, 0.04);
    border-color: rgba(0, 0, 0, 0.12);
  }
  
  [data-theme="light"] .priv-master-toggle-title {
    color: rgba(0, 0, 0, 0.88);
  }
  
  [data-theme="light"] .priv-master-toggle-desc {
    color: rgba(0, 0, 0, 0.55);
  }
  
  [data-theme="light"] .priv-info-banner {
    background: rgba(33, 150, 243, 0.06);
    border-color: rgba(33, 150, 243, 0.18);
  }
  
  [data-theme="light"] .priv-info-banner p {
    color: rgba(0, 0, 0, 0.60);
  }
  
  [data-theme="light"] .priv-link {
    color: #1976d2;
  }
  
  [data-theme="light"] .priv-link:hover {
    color: #1565c0;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Pages/common/Settings/Styles/PrivacySettings.css"],"names":[],"mappings":"AAAA;;qEAEqE;;GAElE;IACC,aAAa;IACb,sBAAsB;IACtB,MAAM;EACR;;EAEA,6EAA6E;EAC7E;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,qCAAqC;IACrC,uCAAuC;EACzC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,SAAO;EACT;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,gCAAgC;IAChC,iBAAiB;EACnB;;EAEA,iFAAiF;EACjF;IACE,gCAAgC;IAChC,mBAAmB;EACrB;;EAEA;IACE;MACE,UAAU;MACV,0BAA0B;IAC5B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA,iFAAiF;EACjF;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,oCAAoC;IACpC,0CAA0C;IAC1C,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE;MACE,UAAU;MACV,4BAA4B;IAC9B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,SAAS;IACT,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,4BAA4B;EAC9B;;EAEA;IACE,cAAc;IACd,0BAA0B;EAC5B;;EAEA,iFAAiF;EACjF;IACE;MACE,sBAAsB;MACtB,uBAAuB;MACvB,SAAS;MACT,kBAAkB;IACpB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,sBAAsB;MACtB,SAAS;MACT,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;MACjB,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,kBAAkB;MAClB,SAAS;IACX;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA,qFAAqF;EACrF;IACE,qCAAqC;IACrC,uCAAuC;EACzC;;EAEA;IACE,qCAAqC;IACrC,uCAAuC;EACzC;;EAEA;IACE,+BAA+B;IAC/B,iCAAiC;EACnC;;EAEA;IACE,+BAA+B;IAC/B,iCAAiC;EACnC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,oCAAoC;IACpC,sCAAsC;EACxC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB","sourcesContent":["/* ==================== PRIVACY SETTINGS STYLES ====================\n   Prefix: priv- to avoid collisions\n   ================================================================ */\n\n   .priv-root {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n  }\n  \n  /* ── Master Toggle ─────────────────────────────────────────────────────── */\n  .priv-master-toggle {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 20px;\n    padding: 18px 20px;\n    background: rgba(255, 255, 255, 0.03);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 12px;\n    margin-bottom: 24px;\n    transition: all 0.2s ease;\n  }\n  \n  .priv-master-toggle:hover {\n    background: rgba(255, 255, 255, 0.05);\n    border-color: rgba(255, 255, 255, 0.12);\n  }\n  \n  .priv-master-toggle-info {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    flex: 1;\n  }\n  \n  .priv-master-toggle-title {\n    font-size: 14px;\n    font-weight: 700;\n    color: rgba(255, 255, 255, 0.88);\n    letter-spacing: 0.3px;\n  }\n  \n  .priv-master-toggle-desc {\n    font-size: 12.5px;\n    color: rgba(255, 255, 255, 0.40);\n    line-height: 1.55;\n  }\n  \n  /* ── Content Section ───────────────────────────────────────────────────────── */\n  .priv-content {\n    animation: priv-fadeIn 0.2s ease;\n    margin-bottom: 20px;\n  }\n  \n  @keyframes priv-fadeIn {\n    from {\n      opacity: 0;\n      transform: translateY(5px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  /* ── Info Banner ───────────────────────────────────────────────────────────── */\n  .priv-info-banner {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    background: rgba(33, 150, 243, 0.08);\n    border: 1px solid rgba(33, 150, 243, 0.20);\n    border-radius: 10px;\n    padding: 14px 16px;\n    margin-top: 16px;\n    animation: priv-slideIn 0.3s ease;\n  }\n  \n  @keyframes priv-slideIn {\n    from {\n      opacity: 0;\n      transform: translateX(-10px);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n  \n  .priv-info-banner span {\n    font-size: 1.2rem;\n    flex-shrink: 0;\n    margin-top: 2px;\n  }\n  \n  .priv-info-banner p {\n    font-size: 13px;\n    color: rgba(255, 255, 255, 0.55);\n    margin: 0;\n    padding: 0;\n    line-height: 1.65;\n  }\n  \n  .priv-link {\n    color: #64b5f6;\n    text-decoration: none;\n    font-weight: 600;\n    transition: color 0.15s ease;\n  }\n  \n  .priv-link:hover {\n    color: #90caf9;\n    text-decoration: underline;\n  }\n  \n  /* ── Responsive Design ─────────────────────────────────────────────────────── */\n  @media (max-width: 768px) {\n    .priv-master-toggle {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 16px;\n      padding: 16px 18px;\n    }\n  \n    .priv-master-toggle-title {\n      font-size: 13px;\n    }\n  \n    .priv-master-toggle-desc {\n      font-size: 12px;\n    }\n  \n    .priv-info-banner {\n      flex-direction: column;\n      gap: 10px;\n      padding: 12px 14px;\n    }\n  \n    .priv-info-banner span {\n      font-size: 1.1rem;\n      margin-top: 0;\n    }\n  \n    .priv-info-banner p {\n      font-size: 12px;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .priv-master-toggle {\n      padding: 14px 16px;\n      gap: 12px;\n    }\n  \n    .priv-master-toggle-title {\n      font-size: 12px;\n    }\n  \n    .priv-master-toggle-desc {\n      font-size: 11px;\n      line-height: 1.5;\n    }\n  \n    .priv-info-banner {\n      padding: 10px 12px;\n    }\n  \n    .priv-info-banner p {\n      font-size: 11px;\n    }\n  }\n  \n  /* ── Dark Theme Compatibility ──────────────────────────────────────────────────── */\n  [data-theme=\"dark\"] .priv-master-toggle {\n    background: rgba(255, 255, 255, 0.02);\n    border-color: rgba(255, 255, 255, 0.06);\n  }\n  \n  [data-theme=\"dark\"] .priv-master-toggle:hover {\n    background: rgba(255, 255, 255, 0.04);\n    border-color: rgba(255, 255, 255, 0.10);\n  }\n  \n  [data-theme=\"light\"] .priv-master-toggle {\n    background: rgba(0, 0, 0, 0.02);\n    border-color: rgba(0, 0, 0, 0.08);\n  }\n  \n  [data-theme=\"light\"] .priv-master-toggle:hover {\n    background: rgba(0, 0, 0, 0.04);\n    border-color: rgba(0, 0, 0, 0.12);\n  }\n  \n  [data-theme=\"light\"] .priv-master-toggle-title {\n    color: rgba(0, 0, 0, 0.88);\n  }\n  \n  [data-theme=\"light\"] .priv-master-toggle-desc {\n    color: rgba(0, 0, 0, 0.55);\n  }\n  \n  [data-theme=\"light\"] .priv-info-banner {\n    background: rgba(33, 150, 243, 0.06);\n    border-color: rgba(33, 150, 243, 0.18);\n  }\n  \n  [data-theme=\"light\"] .priv-info-banner p {\n    color: rgba(0, 0, 0, 0.60);\n  }\n  \n  [data-theme=\"light\"] .priv-link {\n    color: #1976d2;\n  }\n  \n  [data-theme=\"light\"] .priv-link:hover {\n    color: #1565c0;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
